import { useChildren, useParent } from '../utils/components';
export var FORM_BIND_FORM_ITEM_KEY = Symbol('FORM_BIND_FORM_ITEM_KEY');
export function useForm() {
  var {
    bindParent,
    parentProvider
  } = useParent(FORM_BIND_FORM_ITEM_KEY);
  return {
    bindForm: bindParent,
    form: parentProvider
  };
}
export function useFormItems() {
  var {
    bindChildren,
    childProviders
  } = useChildren(FORM_BIND_FORM_ITEM_KEY);
  return {
    formItems: childProviders,
    bindFormItems: bindChildren
  };
}